import { atom } from 'recoil';

export const UserAgentState = atom<'MOBILEWEB' | 'PCWEB' | ''>({
  key: 'UserAgentState',
  default: '',
});

export const PCodeState = atom<string>({
  key: 'PCodeState',
  default: '046f13e8-8897', //제휴사 코드 없는 경우(제휴웹가입코드)
});
